import {Clip, KeyMomentClip} from "../types/clipTypes";
import {jobSSE} from "../types/jobDataTypes";
import {ClipGroup} from "../types/mamTypes";

export type SortOrder = Record<string, number>;

export function sortByCustomOrderThenDate<T>(
    data: T[],
    primaryKey: keyof T,
    secondaryKey: keyof T,
    sortOrder: SortOrder,
    dateOrder: 'asc' | 'desc' = 'desc'
): T[] {
    return data.sort((a, b) => {
        const primaryA = a[primaryKey] as keyof typeof sortOrder;
        const primaryB = b[primaryKey] as keyof typeof sortOrder;

        const primaryDiff = (sortOrder[primaryA] ?? Infinity) - (sortOrder[primaryB] ?? Infinity);

        if (primaryDiff !== 0) return primaryDiff;

        const dateA = new Date(a[secondaryKey] as string).getTime();
        const dateB = new Date(b[secondaryKey] as string).getTime();

        return dateOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });
}

export function sortClipByEventStream(clip1: Clip | KeyMomentClip, clip2: Clip | KeyMomentClip, reverse: boolean = false) {
        const c1StartTime = clip1.stream_time_start ? clip1.stream_time_start : 0;
        const c2StartTime = clip2.stream_time_start ? clip2.stream_time_start : 0;
        return reverse ? c2StartTime - c1StartTime : c1StartTime - c2StartTime;
}


export function markEditedGroupClips(jobsRunning: jobSSE[], clipGroups: ClipGroup[]){
    const editingJob = jobsRunning.filter(job => job.type==="editing").map(job => job.settings.video_content_id)
    const editingJobClips = new Set(editingJob)
    let change = false
    for (const clipGroup of clipGroups) {
        const clipPreset = editingJobClips.has(clipGroup.id)
        if (clipPreset && !clipGroup.editing) {
            clipGroup.editing = true
            change = true
        } else if (!clipPreset && clipGroup.editing) {
            clipGroup.editing = false
            change = true
        }
    }
    return {change, clipGroups}
}